import { Area,Tooltip,ResponsiveContainer,AreaChart,XAxis,YAxis,CartesianGrid } from 'recharts';

 const RenderLineChart = (props) => {
    const { data } = props;


   return (
     <div>
       <ResponsiveContainer width='90%' aspect={15.0/4.0}>
       <AreaChart data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Area type="monotone" dataKey="close" stroke="#8884d8" fillOpacity={0} fill="url(#colorUv)" />
          <Area type="monotone" dataKey="high" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
        </AreaChart>
        </ResponsiveContainer>
     </div>
    
    );
   }

export default RenderLineChart